import styles from "./CardDetails.module.css";

export default function CardDetails({ details }) {
  if (!details?.length) return null;

  return (
    <ul className={styles.cardDetails}>
      {details.map((item, index) => (
        <li key={index}>
          <strong>{item.label} :</strong> {item.value}
        </li>
      ))}
    </ul>
  );
}
